export default {
    onClick: function () {
        this.element.find('.dropdown-menu').on('click', (e) => {
            e.stopPropagation();
        })
    },
}